// components/Staffrecord/Editform/Qualification.jsx
import React from 'react';

const Qualification = ({ formData }) => {
  const formatValue = (value, suffix = '') => (value ? `${value}${suffix}` : '');

  // ✅ Format date for display
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
  };

  // ✅ Get experience details from formData
  const getExperienceDetails = () => {
    const details = [
      {
        companyName: formData.expCompanyName1 || "",
        startDate: formData.expStartDate1 || "",
        endDate: formData.expEndDate1 || "",
        role: formData.expRole1 || "",
        technologies: formData.expTechnologies1 || "",
        currentlyWorking: formData.expCurrentlyWorking1 || false
      },
      {
        companyName: formData.expCompanyName2 || "",
        startDate: formData.expStartDate2 || "",
        endDate: formData.expEndDate2 || "",
        role: formData.expRole2 || "",
        technologies: formData.expTechnologies2 || "",
        currentlyWorking: formData.expCurrentlyWorking2 || false
      },
      {
        companyName: formData.expCompanyName3 || "",
        startDate: formData.expStartDate3 || "",
        endDate: formData.expEndDate3 || "",
        role: formData.expRole3 || "",
        technologies: formData.expTechnologies3 || "",
        currentlyWorking: formData.expCurrentlyWorking3 || false
      }
    ];

    // Only return rows that have at least one field filled
    return details.filter(row => 
      row.companyName || row.role || row.technologies || row.startDate || row.endDate
    );
  };

  const experienceDetails = getExperienceDetails();
  const hasExperience = formData.experience && formData.experience !== "Fresher";

  return (
    <div>
      {/* ====================== EDUCATION TABLE ====================== */}
      <div className="education-table">
        <table>
          <thead>
            <tr>
              <th>Education Level</th>
              <th>Degree</th>
              <th>Department</th>
              <th>Institution Name and Address</th>
              <th>Passed Out Year</th>
              <th>Percentage / CGPA</th>
            </tr>
          </thead>
          <tbody>
            {/* 10th Row */}
            <tr>
              <td>10th</td>
              <td>{formatValue(formData.tenthDegree)}</td>
              <td>{formatValue(formData.tenthDepartment)}</td>
              <td>{formatValue(formData.tenthInstitution)}</td>
              <td>{formatValue(formData.tenthPassout)}</td>
              <td>{formatValue(formData.tenthPercentage, '%')}</td>
            </tr>

            {/* 12th Row */}
            <tr>
              <td>12th</td>
              <td>{formatValue(formData.twelfthDegree)}</td>
              <td>{formatValue(formData.twelfthDepartment)}</td>
              <td>{formatValue(formData.twelfthInstitution)}</td>
              <td>{formatValue(formData.twelfthPassout)}</td>
              <td>{formatValue(formData.twelfthPercentage, '%')}</td>
            </tr>

            {/* Diploma Row */}
            <tr>
              <td>Diploma</td>
              <td>{formatValue(formData.diplomaDegree)}</td>
              <td>{formatValue(formData.diplomaDepartment)}</td>
              <td>{formatValue(formData.diplomaInstitution)}</td>
              <td>{formatValue(formData.diplomaPassout)}</td>
              <td>{formatValue(formData.diplomaPercentage, '%')}</td>
            </tr>

            {/* UG Row */}
            <tr>
              <td>UG</td>
              <td>{formatValue(formData.ugDegree)}</td>
              <td>{formatValue(formData.ugDepartment)}</td>
              <td>{formatValue(formData.ugInstitution)}</td>
              <td>{formatValue(formData.ugPassout)}</td>
              <td>{formatValue(formData.ugPercentage)}</td>
            </tr>

            {/* PG Row */}
            <tr>
              <td>PG</td>
              <td>{formatValue(formData.pgDegree)}</td>
              <td>{formatValue(formData.pgDepartment)}</td>
              <td>{formatValue(formData.pgInstitution)}</td>
              <td>{formatValue(formData.pgPassout)}</td>
              <td>{formatValue(formData.pgPercentage)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* ====================== EXPERIENCE SECTION ====================== */}
      <div className="experience-section" style={{ marginTop: '30px' }}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontWeight: 'bold', fontSize: '16px' }}>Work Experience: </label>
          <span style={{ marginLeft: '10px', fontSize: '15px' }}>
            {formData.experience || "Not Provided"}
          </span>
        </div>

        {/* ✅ SHOW EXPERIENCE TABLE IF NOT FRESHER */}
        {hasExperience && experienceDetails.length > 0 && (
          <div className="experience-table-container">
            <table className="experience-table">
              <thead>
                <tr>
                  <th>Company Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Role</th>
                  <th>Technologies</th>
                </tr>
              </thead>
              <tbody>
                {experienceDetails.map((row, index) => (
                  <tr key={index}>
                    <td>{row.companyName || "-"}</td>
                    <td>{formatDate(row.startDate)}</td>
                    <td>{row.currentlyWorking ? "Present" : formatDate(row.endDate)}</td>
                    <td>{row.role || "-"}</td>
                    <td>{row.technologies || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Qualification;